module.exports = __webpack_public_path__ + "img/2_list4.d39fb909.png";